import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../data-access/api';
import { User } from '../models/user.models';

@Injectable({
  providedIn: 'root',
})
export class MembershipService {
  constructor(
    @Inject(HttpClient) private http: HttpClient,
    @Optional() @Inject(API_BASE_URL) private baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = `${baseUrl}/membership`;
  }

  getUserProfile(endpoint = '/user/me'): Observable<User> {
    return this.http.get(`${this.baseUrl}${endpoint}`);
  }
}
